import React from 'react';
import { EmailStatusLabel } from 'areas/shared/controls';

const TaggedOption = (props) => {
	return (
			<div style={{textAlign: 'center', verticalAlign: 'middle'}}>
				<EmailStatusLabel emailStatusCode={props.data.value} /> 
			</div>	
	);
};

export default TaggedOption;


// WEBPACK FOOTER //
// ./src/areas/shared/controls/emailStatusCombo/TaggedOption.js